<template>
  <div class="header">
   
    <div class="left">
      <div class="logo">
        <img style="width: 210px; height: 52px" src="../../assets/logo.png" alt />
      </div>
        <div class="link" ref="menuDemo">
          <el-menu
          :default-active="$route.path | getRouterActive"
          class="el-menu-demo"
          mode="horizontal"
          text-color="#333"
          active-text-color="#fff"
          @select="handleSelect"
          :router="true"
        >
          <el-menu-item
            :index="item.path"
            v-for="item in visibleRoutes"
            :key="item.id"
            @click="meunchange(item)"
            class="el-menu-item"
          >
            <p class="title" :style="innerWidth">{{ item.meta.title }}</p>
          </el-menu-item>
          <el-dropdown v-if="hiddenRoutes.length > 0" trigger="hover" placement="bottom">
            <span class="title" style="cursor: pointer;font-size:18px;font-weight: 600;color: #333;text-align: center;">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
              v-for="(route, index) in hiddenRoutes"
              :key="index"
              :index="route.path"
              @click.native="navigateTo(route.path)"
            >
              {{ route.meta.title }}
        </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </el-menu>
          
        
        </div>
        
        <div class="user">
          <div class="setting">
          <div class="title" v-if="isemail" @click="goemail()">
            <el-badge :value="$store.state.total" class="item">
              <i class="el-icon-message"></i>
            </el-badge>
          </div>

          <div class="title" v-if="isset" @click="goset()">
            <i class="el-icon-setting"></i>
          </div>
        </div>
        <div class="noticecenter"></div>

        <div class="avatar">
          <img style="width: 100% 100%" src="../../assets/avatar.png" alt />
        </div>

        <div style="display: flex; flex-direction: column; cursor: pointer">
          <el-dropdown>
            <span class="el-dropdown-link nickname">
              你好，{{ loginName
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="outlogin"
                >退出登录</el-dropdown-item
              >
              <el-dropdown-item @click.native="clickEditPW"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item @click.native="clickDownFile"
                >手册下载</el-dropdown-item
              >
            </el-dropdown-menu>
            
          </el-dropdown>

          <!-- <span class="nickname">你好，{{ loginName }}</span>

          <span
            style="font-size: 12px; color: #718096; cursor: pointer"
            @click="outlogin()"
            >退出登录</span
          > -->
        </div>
       
      </div>
    </div>
   
    <!--修改密码  -->
    <!-- 修改密码 -->
    <el-dialog
      title="密码修改"
      @close="pwdclose"
      :modal-append-to-body="false"
      :visible.sync="isPwd"
      width="30%"
    >
      <el-form
        ref="pwdform"
        :model="passwordForm"
        :rules="rulesPWD"
        label-width="150px"
      >
        <el-form-item label="请输入原密码：" prop="yPassword">
          <el-input
            type="password"
            v-model="passwordForm.yPassword"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入新密码：" prop="xPassword1">
          <el-input
            type="password"
            v-model="passwordForm.xPassword1"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="请再次确认新密码：" prop="xPassword2">
          <el-input
            type="password"
            v-model="passwordForm.xPassword2"
            placeholder="请再次确认新密码"
          ></el-input>
        </el-form-item>
        <el-form-item> </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdclose">取 消</el-button>
        <el-button type="primary" @click="sunmitpwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { NoticeUnread } from '../../api/First'
import { changePassword } from '../../api/login'
import {ExportHandbook} from  '../../api/set.js'
import { requestDownLoadFilePC } from '../../api/seal.js'

// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
export default {
  name: 'Header',
  // props:["routes"],
  data() {
    // 密码验证
    var checkpwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('不能为空'))
      }
      //let regpwd = /^[a-zA-Z0-9_-]{6,16}$/;
      //let regpwd = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#%^&]{6,16}$)/;
      let regpwd = value.length
      setTimeout(() => {
        if (regpwd < 6 || regpwd > 16) {
          //if (!regpwd.test(value)) {
          callback(new Error('请输入6到16位的密码'))
        } else {
          callback()
        }
      }, 500)
    }
    return {
      // menuItem: [
      //   { id: 0, title: "首页", content: "HOMEPAGE", path: "/home/homepage" },
      //   { id: 1, title: "案例管理", content: "case", path: "/home/case" },
      //   // { id: 2, title: "项目", content: "POSITION", path: "/home/position" },
      //   // { id: 3, title: "客户", content: "CUSTOMER", path: "/home/customer" },
      //   // { id: 4, title: "项目", content: "POSITION", path: "/home/position" },
      //   // { id: 5, title: "客户", content: "CUSTOMER", path: "/home/customer" },
      // ],
      navarr: [],
      dropdownVisible: false,
      dropdownMenus: [],
      totalWidth :'',//总宽度
      activeIndex:'',

      allMenu:[],//所有菜单
      visibleRoutes:[],
      hiddenRoutes:[],
      isemail: false,
      isset: false,
      loginName: '',
      UnReadCount: '', //未读条数
      count: 0,
      passwordForm: {},
      rulesPWD: {
        yPassword: [{ required: true, trigger: 'blur', validator: checkpwd }],
        xPassword1: [{ required: true, trigger: 'blur', validator: checkpwd }],
        xPassword2: [{ required: true, trigger: 'blur', validator: checkpwd }]
      },
      isPwd: false,
      innerWidth: 'font-size:20px;',
      getRouterActive:'',
    }
  },
  created() {
    // console.log('9999',   window.sessionStorage.getItem('userId'));
    // this.GetActiveIndex()
    this.navFilter()
    this.GetUnRead()
    this.judgeInnerWith()
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1210) {
        this.innerWidth = 'font-size:18px;'
      } else if (window.innerWidth < 1340) {
        this.innerWidth = 'font-size:18px;'
      } else {
        this.innerWidth = 'font-size:18px;'
      }
    }) 
    this.GetvisibleRoutes()
    window.addEventListener('resize', this.GetvisibleRoutes);
    // this.scrollToSelectedItem()
  },
  methods: {
    navigateTo(path) {
      console.log(path)
      this.$router.push(path);
    },
    GetActiveIndex(){
      var path=this.$route.path
      console.log(path)
      this.activeIndex= path
    },
    judgeInnerWith() {
      if (window.innerWidth < 1210) {
        this.innerWidth = 'font-size:18px;'
      } else if (window.innerWidth < 1340) {
        this.innerWidth = 'font-size:18px;'
      } else {
        this.innerWidth = 'font-size:18px;'
      }
    },
    //修改密码
    //修改
    clickEditPW() {
      this.isPwd = true
    },
    clickDownFile(){
      ExportHandbook().then((res)=>{
        if(res.data.status=='success'){
          this.down(res.data.data)
        }else{
          this.$message.error(res.data.message)
        }
      })
      // // window.location.href = '调查取证申请书.docx';
      // var a = document.createElement("a"); //创建一个<a></a>标签
      // a.href = "/操作手册.docx"; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      // a.download = "操作手册.docx"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      // a.style.display = "none"; // 障眼法藏起来a标签
      // document.body.appendChild(a); // 将a标签追加到文档对象中
      // a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      // a.remove(); // 一次性的，用完就删除a标签
    },
    async down(item) {
      // this.isLoading = true
      const res = await requestDownLoadFilePC({
        Id: item.id
      })
      if (res.status == '201') {
        this.$message.error('找不到文件')
        // this.isLoading = false
        return
      }
      console.log(res.data.type)
      if (res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          // console.log(jsonData)
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      fileReader.readAsText(data)
      // this.isLoading = false
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ext.slice(1)
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      console.log(fileType)
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name)
        // this.isLoading = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    //修改取消按钮
    pwdclose() {
      this.$refs['pwdform'].resetFields()
      this.passwordForm = {}
      this.isPwd = false
    },
    //修改确认按钮
    sunmitpwd() {
      this.$refs['pwdform'].validate((valid) => {
        if (valid) {
          if (this.passwordForm.xPassword1 != this.passwordForm.xPassword2) {
            this.$message.error('请输入相同的新密码')
          } else {
            let Params = {
              OldPassWord:
                this.passwordForm.yPassword == ''
                  ? null
                  : this.passwordForm.yPassword,
              NewPassWord:
                this.passwordForm.xPassword1 == ''
                  ? null
                  : this.passwordForm.xPassword1,
              id: window.sessionStorage.getItem('userId')
            }
            changePassword(Params)
              .then((res) => {
                if (res.data.status != 'success') {
                  this.$message.error(res.data.message)
                  return
                }
                if (res.status == 200) {
                  // this.getMessage()
                  this.$message.success('修改成功')

                  // this.form = res.data.data
                } else {
                  this.$message.error('查询出错')
                }
              })
              .catch(() => {
                console.log('查询出错')
              })
            this.isPwd = false
          }
        }
      })
    },
    handleSelect(index) {
      if (index !== 'dropdown') {
          this.activeIndex = index;
        } else {
          this.dropdownVisible = !this.dropdownVisible;
        }
      
      this.$store.commit('setPage', 1)
    },
    outlogin() {
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('hasRoles')
      this.$router.push('/login')
      this.$message({ message: '退出成功', type: 'success' })
    },
    GetUnRead() {
      NoticeUnread().then((res) => {
        if (res.data.status == 'success') {
          // console.log('res.data.total',res.data);
          if (res.data.total > 0) {
            this.UnReadCount = res.data.total
            this.$store.commit('MessageTotal', res.data.total)
          } else {
            this.UnReadCount = ''
            this.$store.commit('MessageTotal', '')
          }
        }
      })
    },
    navFilter() {
      var arr = []
      this.loginName = this.$store.state.name
      this.routes.forEach((element, index) => {
        if (element.name == 'email') {
          this.isemail = true
          this.count = this.count + 1
          // console.log('isemail111',this.isemail);
        }
        if (element.name == 'set') {
          this.count = this.count + 1
          this.isset = true
          // console.log('isemail111',this.isemail);
        }
        element.path = '/home/' + element.path
        arr.push(element)
      })
      // console.log("oooooooo",arr);
      arr.splice(arr.length - this.count, this.count)
      // arr.splice(arr.length - 2, 2)
      this.navarr = arr
      this.allMenu = arr
    },
    goemail() {
      this.$router.push('/home/email')
    },
    goset() {
      this.$router.push('/home/set')
    },
    // GetTotal(total) {//传值给父组件，
    //    this.
    // },
    meunchange(item) {
      // localStorage.setItem("menustatus", "0");
      // this.$store.state.menustatus = localStorage.getItem("menustatus");
      this.$store.commit('setmenustatus', 0)
      this.$store.commit('setinputstatus', 0)
     
      // this.scrollToSelectedItem()
      // this.$store.state.inputstatus = 0;
      // const index = this.navarr.findIndex(
      //   (item) => item.path === event.currentTarget.getAttribute("index")
      // );
      // const itemWidth = this.$refs.menu.$el.getBoundingClientRect().width;
      // const containerWidth = this.$refs.menu.$el.getBoundingClientRect().width;
      // const leftEdge = this.$refs.menu.$el.scrollLeft;
      // const rightEdge = leftEdge + containerWidth;
      // const itemLeftEdge = index * itemWidth;
      // const itemRightEdge = itemLeftEdge + itemWidth;

      // // 如果菜单项超出容器的右边界，则计算出应该滚动的距离
      // if (itemRightEdge > rightEdge) {
      //   const scrollDistance = itemLeftEdge - (rightEdge - containerWidth);
      //   this.$refs.menu.$el.scrollTo({
      //     left: scrollDistance,
      //     behavior: "smooth",
      //   });
      // }
    },
    scrollToSelectedItem() {
      
      this. $nextTick(()=>{
        const SelectmenuItem = document.querySelector('.el-menu-item.is-active');
        if (SelectmenuItem) {
        
        const menuContainer = document.querySelector('.el-menu');//整个菜单
        const menuContainerWidth = menuContainer.offsetWidth;//整个显示区域的宽度
        console.log("显示区域的宽度",menuContainerWidth)
        
        // const SelectItemWidth = SelectmenuItem.offsetWidth;//选中宽度
        // const SelectItemLeft = SelectmenuItem.offsetLeft;//左边距

        // if(SelectItemLeft<menuContainerWidth&&SelectItemLeft>menuContainerWidth/2){
           
        //     menuContainer.scrollLeft += 150
        //     console.log("右击")
        // }
        // else if(SelectItemLeft>menuContainerWidth&&(SelectItemLeft- menuContainer.scrollLeft)>menuContainerWidth/2){
        //   menuContainer.scrollLeft += 150
        //   console.log("右+")
        // }else if(SelectItemLeft>menuContainerWidth&&(SelectItemLeft- menuContainer.scrollLeft)<menuContainerWidth/2){
        //   menuContainer.scrollLeft -= 150
        //   console.log("左-")
        // }
        var rent =SelectmenuItem.getBoundingClientRect();
        var xdl=rent.x-230+rent.width-menuContainerWidth/2
        console.log(xdl)
        menuContainer.scrollLeft += xdl
        console.log(menuContainer.scrollLeft)
        // if(rent.x-230+rent.width>menuContainerWidth/2){
        //   menuContainer.scrollLeft += xdl
        //     console.log("右击")
        // }else{
        //     menuContainer.scrollLeft -= xdl
        //     console.log("左-")
        // }
        // console.log("选中宽度",SelectItemWidth)
        // console.log("左边距",SelectItemLeft)
        // console.log("偏移量",menuContainer.scrollLeft)
      

       
      }
      })
      
     
   
  },
  calculateDropdownMenus() {
    this. $nextTick(()=>{
      // 假设屏幕宽度为1200px
        const screenWidth = this.$refs.menuDemo.offsetWidth;
      
        const menuItems = this.$el.querySelectorAll('.el-menu-item');

        let totalWidth = 0;
        // console.log(menuItems)
        // 计算所有菜单项的总宽度

        menuItems.forEach(item => {
          totalWidth += item.offsetWidth;
        });
        console.log(totalWidth)
        // 如果总宽度超过屏幕宽度，将超出部分的菜单项放入下拉菜单
        if (totalWidth > screenWidth) {
          
          let index = 0;
          for(index;index < menuItems.length;index++){
             const ItemWidth = menuItems[index].offsetWidth;//选中宽度
             const ItemLeft = menuItems[index].offsetLeft;//左边距
             console.log(index,ItemWidth+ItemLeft)
             if(ItemWidth+ItemLeft>screenWidth){
                
                break
             }
          }
       
         
          // 将剩余的菜单项放入下拉菜单
         
          this.dropdownMenus = this.allMenu.slice(index).map(item => ({
            name:item.meta.title,
            path: item.path
          }));
          this.navarr= this.allMenu.slice(0,index)
        }
       
        console.log(this.navarr)
      })
    
    },
    GetvisibleRoutes() {
      const pageWidth = window.innerWidth - 560 <360?360:window.innerWidth - 560// 获取页面宽度
    
      // console.log(pageWidth)
      // 计算可见的菜单项
      const visibleRoutes = [];
      let currentWidth =56;
      // console.log(this.allMenu)
      for (const route of this.allMenu) {
        const itemWidth = this.estimateItemWidth(route); // 估计每个菜单项的宽度
        // console.log(itemWidth)
        if (currentWidth + itemWidth <= pageWidth) {
          visibleRoutes.push(route);
          currentWidth += itemWidth;
        } else {
          break;
        }
      }
      // console.log(currentWidth)
      // console.log(visibleRoutes)

      this.visibleRoutes=visibleRoutes ;
      this.GethiddenRoutes()
    },
    GethiddenRoutes() {
      // 计算隐藏的菜单项
      this.hiddenRoutes= this.allMenu.filter(route => !this.visibleRoutes.includes(route));
    },
   estimateItemWidth(route) {
      // 创建一个隐藏的span元素
      const span = document.createElement('span');
      span.style.position = 'absolute'; // 绝对定位，不占据空间
      span.style.visibility = 'hidden'; // 隐藏元素
      span.style.whiteSpace = 'nowrap'; // 不换行
      span.style.fontWeight='600';
      span.style.fontSize='20px';
      span.style.textAlign='center';
     
      span.innerText = route.meta.title; // 设置文本内容

      // 将span元素添加到body中
      document.body.appendChild(span);

      // 等待Vue更新DOM
      this.$nextTick();

      // 测量文本宽度
      const width =span.offsetWidth<=100? span.offsetWidth+40:150;
      
      // 移除span元素
      document.body.removeChild(span);
   
      return width;
    },
  
  },
  mounted() {
    // 计算屏幕宽度并决定哪些菜单项应该放入下拉菜单
    // this.calculateDropdownMenus();
  },
  filters: {
    getRouterActive(path) {
      // console.log(path)
      return '/' + path.split('/')[1] + '/' + path.split('/')[2]
    }
  },
  watch: {
    $route(to, from) {
      this.GetUnRead()
      // this.scrollToSelectedItem()
    },
   
  },
  computed: {
    // UnReadCount() {
    //   return UnReadCount;
    // },
    routes() {
      return this.$store.state.permission.addRoutes
    },
  
    // menuTotalWidth() {
    //   let totalWidth = 0;
    //   this.visibleRoutes.forEach(route => {
    //     this.estimateItemWidth(route).then(width => {
    //       totalWidth += width;
    //       this.$set(this, 'menuTotalWidth', totalWidth);
    //     });
    //   });
    //   this.hiddenRoutes.forEach(route => {
    //     this.estimateItemWidth(route).then(width => {
    //       totalWidth += width;
    //       this.$set(this, 'menuTotalWidth', totalWidth);
    //     });
    //   });
    //   return totalWidth;
    // },
  }
}
</script>

<style lang="less" scoped>
.header {
  height: 100%;
  width:100%;
  
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: solid 1px #e6e6e6;
  white-space: nowrap;
  padding-right: 10px;
  z-index: 3;
  // box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
  .logo {
    // width: 207px;
    height: 52px;
    background-size: 100% 100%;
    margin: 0 0 0 10px;
    display: flex;
    align-items: center;
    width: 220px;
    
  }
  .left{
    width:100%;
    display: flex;
    align-items: center;
  }
  .el-row {
    height: 100%;
    width: 100%;
  }

  // .logo {
  //   min-width: 250px;
  //   div {
  //     height: 100%;
  //     width: 100%;
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     img {
  //       height: 80%;
  //     }
  //   }
  // }
  .avatar {
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    min-width: 40px;
  }

  .nickname {
    font-size: 16px;
    font-weight: bold;
    color: #111827;
  }

  .link {
    height: 100%;
    width:calc( 100% - 560px);
    min-width: 360px;
    display: flex;
    align-items: center;
  .el-menu {
    overflow-x: hidden;
    white-space: nowrap;
  }
  /deep/ .el-menu.el-menu--horizontal {
    border-bottom: none; /* 移除底部边框 */
  }
    .el-menu-demo {
      display: flex;
      width: 100%;
      height: 100%;
      // min-width: 400px;
        align-items: center;
        // overflow-x: auto; /* 启用水平滚动 */

      .el-menu-item {
        width: 150px;
        height: 100%;
        display: inline-block; /* 使菜单项水平排列 */
       
        .title {
            white-space: nowrap;
            font-weight: 600;
            font-size: 20px;
            color: #333;
            // width:150px;
            text-align: center;
          }

          .con {
            color: #e6e6e6;
          }
       

        &:hover {
          background-color: #fff;
          color: #409eff;
        }
      }

      .el-menu-item.is-active {
        border-bottom: 0;
        width: 150px;
        height: 100%;
        display: inline-block; /* 使菜单项水平排列 */
        .title {
          color: #409eff;
        }
      }

      .el-menu-item [class^='el-icon-'] {
        font-size: 20px;
        color: #111827;
        font-weight: bolder;
      }
    }
  }
  /deep/ .link::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
  .user {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 230px;
    margin-left: 30px;
    .setting {
      display: flex;
      width: 100px;
      cursor: pointer;
      // justify-content: center;
      align-items: center;

      .title {
        width: 40px;
        font-weight: 800 !important;
        font-size: 20px;
        color: #333;

        [class*=' el-icon-'],
        [class^='el-icon-'] {
          font-weight: 500;
          font-size: 22px;
          color: black;
        }
      }
    }

    .noticecenter {
      width: 1px;
      height: 50px;
      margin: 0 10px;
      background-color: #eeeff2;
    }

    p {
      font-size: 14px;
      margin-top: 20px;
      color: #333;
    }
  }
}
.link > ul {
    /*width: 840px;*//*带icon的*/
    width: 100%;/*不带icon的*/
  }
  .link .el-menu--horizontal>.el-menu-item {
    height: 55px;
    line-height: 55px;
  }
  .link .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 55px;
    line-height: 55px;
  }

</style>
